export const PARTS_MAP = {
    ['attackVector']: 'Attack Vector',
    ['attackComplexity']: 'Attack Complexity',
    ['privilegesRequired']: 'Privileges Required',
    ['userInteraction']: 'User Interaction',
    ['accessVector']: 'Access Vector',
    ['accessComplexity']: 'Access Complexity',
    ['authentication']: 'Authentication',
    ['confidentialityImpact']: 'Confidentiality Impact',
    ['integrityImpact']: 'Integrity Impact',
    ['availabilityImpact']: 'Availability Impact',
    ['scope']: 'Scope',
    ['percentile']: 'Percentile',
    ['confidence']: 'Confidence',
    ['Automatable']: 'Automatable',
    ['Exploitation']: 'Exploitation',
    ['Technical Impact']: 'Technical Impact'
} as const;
